import { useOfflineSync } from "@/context/OfflineSyncContext";
import { CloudArrowUp, CloudSlash } from "@phosphor-icons/react";

export function SyncIndicator() {
  const { pending, online, sync, busy } = useOfflineSync();

  // Dezent: nur anzeigen, wenn offline oder es offene Erfassungen gibt.
  if (online && pending === 0) return null;

  if (!online) {
    return (
      <div data-testid="sync-indicator-offline"
        className="inline-flex items-center gap-1.5 rounded-full border border-amber-500/40 bg-amber-500/10 px-2.5 py-1 text-xs font-semibold text-amber-700"
        title="Offline — Erfassungen werden lokal gespeichert">
        <CloudSlash size={15} weight="bold" />
        <span className="hidden sm:inline">Offline{pending > 0 ? ` · ${pending}` : ""}</span>
      </div>
    );
  }

  return (
    <button type="button" onClick={sync} disabled={busy} data-testid="sync-indicator"
      className="relative inline-flex items-center gap-1.5 rounded-full border border-border bg-muted/50 px-2.5 py-1 text-xs font-semibold text-foreground transition-colors hover:bg-accent disabled:opacity-60"
      title={`${pending} offline erfasste Komponente(n) — jetzt synchronisieren`}>
      <CloudArrowUp size={15} weight="bold" className={busy ? "animate-pulse" : ""} />
      <span className="hidden sm:inline">{busy ? "Synchronisiere …" : `${pending} offline`}</span>
      <span data-testid="sync-indicator-count"
        className="flex h-4 min-w-4 items-center justify-center rounded-full bg-primary px-1 text-[10px] font-bold text-primary-foreground sm:hidden">
        {pending > 99 ? "99+" : pending}
      </span>
    </button>
  );
}
